import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { UserFragment, ArtworkFragment, CollectionFragment } from '../hasura-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type UsersByPublicKeysVariables = Types.Exact<{
  publicKeys: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type UsersByPublicKeys = { users: Array<Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>> };



export const UsersByPublicKeysDocument = /*#__PURE__*/ `
    query UsersByPublicKeys($publicKeys: [String!]!) {
  users: user(where: {publicKey: {_in: $publicKeys}}) {
    ...UserFragment
  }
}
    ${UserFragment}`;

export const useUsersByPublicKeys = <
      TData = UsersByPublicKeys,
      TError = ClientError
    >(
      variables: UsersByPublicKeysVariables,
      options?: Omit<UseQueryOptions<UsersByPublicKeys, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UsersByPublicKeys, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UsersByPublicKeys, TError, TData>(
      {
    queryKey: ['UsersByPublicKeys', variables],
    queryFn: hasuraFetcher<UsersByPublicKeys, UsersByPublicKeysVariables>(UsersByPublicKeysDocument, variables),
    ...options
  }
    )};

useUsersByPublicKeys.getKey = (variables: UsersByPublicKeysVariables) => ['UsersByPublicKeys', variables];

export const useInfiniteUsersByPublicKeys = <
      TData = InfiniteData<UsersByPublicKeys>,
      TError = ClientError
    >(
      variables: UsersByPublicKeysVariables,
      options: Omit<UseInfiniteQueryOptions<UsersByPublicKeys, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UsersByPublicKeys, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UsersByPublicKeys, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UsersByPublicKeys.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<UsersByPublicKeys, UsersByPublicKeysVariables>(UsersByPublicKeysDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUsersByPublicKeys.getKey = (variables: UsersByPublicKeysVariables) => ['UsersByPublicKeys.infinite', variables];


useUsersByPublicKeys.fetcher = (variables: UsersByPublicKeysVariables, options?: RequestInit['headers']) => hasuraFetcher<UsersByPublicKeys, UsersByPublicKeysVariables>(UsersByPublicKeysDocument, variables, options);
